import { forwardRef } from 'react';

import { FormMessage, useFormField } from '@/components/ui/form';
import type { InputProps } from '@/components/ui/input';
import { Input } from '@/components/ui/input';

export interface FormInputProps extends InputProps {
  description?: string;
  orientation?: 'horizontal' | 'vertical';
  hideFormMessage?: boolean;
  isPassword?: boolean;
  disableAutoFill?: boolean;
}

const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
  ({ disabled, description, orientation, hideFormMessage, isPassword, disableAutoFill, ...props }, ref) => {
    const { error, id, name } = useFormField();

    return (
      <>
        <Input
          ref={ref}
          disabled={disabled}
          error={error !== undefined}
          orientation={orientation}
          isPassword={isPassword}
          disableAutoFill={disableAutoFill}
          id={id ?? name}
          name={name}
          {...props}
        />

        {!hideFormMessage && <FormMessage className="ml-auto mt-1 text-right text-sm font-normal" />}
      </>
    );
  },
);

FormInput.displayName = 'FormInput';
export { FormInput };
